<template>
  <div class="navigation-tabs">
    <Button
      v-for="(tab, index) in tabs"
      :key="tab.label || index"
      :class="getTabClass(tab)"
      :icon-left="tab?.iconLeft"
      :label="tab?.label"
      @click="onClickTab(tab)"
    />
  </div>
</template>

<script setup>
// Imports
import { useRoute, useRouter } from 'vue-router';
import { Button } from '@/components';

// Component Options

// Props and Emits
defineProps({
  tabs: {
    type: Object,
    required: true,
  },
});
// Composition API Helpers

// Reactive Variables
const route = useRoute();
const router = useRouter();

// Computed Properties

// Watchers

// Lifecycle Hooks

// Methods
const getTabClass = (tab) => {
  return { active: route.name === tab.routeName, 'navigation-tab': true };
};
const onClickTab = (tab) => {
  router.push({ name: tab.routeName });
};
</script>

<style lang="sass" scoped>
.navigation-tabs
  margin-left: 1px
  display: flex
  & :deep(.navigation-tab)
    transition: background-color 0.3s, border-color 0.3s, color 0.3s
    padding: 25px 80px
    &:not(:last-child)
      border-right: none
    border-radius: 0
    font-weight: 600
    &.active, &:hover
        background-color: $primary
        border-color: $primary
        color: white
    .icon i:before
        font-size: 16px
</style>
